
//Site Specific JS
import Configurators from './components/configurators';
import AB1200 from './components/ab-1200-app';
import GenusProductConfigurator from './components/genus-product-configurator';
import WhereToBuy from './components/where-to-buy';
import Profile from './components/profile';

new Configurators();
new AB1200();
new GenusProductConfigurator();
new WhereToBuy(); // js-where-to-buy
new Profile();